// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2eGhC"};